import { Button, FormFieldInput, SelectFormField, SelectOption } from "@/shared/components";
import { useFormContext } from "react-hook-form";
import { getMaterieelTypeOptions } from "../shared/utils";
import { AddTreinFormData } from "./add-betrokken-trein-dialog";

type TreinType = "IC" | "ICD" | "SPR";

const treinTypeOptions: SelectOption<TreinType>[] = [
    { value: "IC", label: "IC" },
    { value: "ICD", label: "ICD" },
    { value: "SPR", label: "SPR" },
];

type AddTreinFormContentProps = {
    showBack: boolean;
};

export function AddTreinFormContent({ showBack = false }: AddTreinFormContentProps) {
    const form = useFormContext<AddTreinFormData>();
    const treinId = form.watch("treinId");
    const materieelAanduiding = form.watch("materieelAanduiding");

    return (
        <div>
            {showBack && (
                <Button icon="arrow-left" onClick={() => form.setValue("treinId", "")} variant="tertiary" className="mb-5 px-0 font-normal">
                    vorige
                </Button>
            )}
            <div className="grid grid-cols-12 gap-4">
                <div className="col-span-4">
                    <SelectFormField
                        form={form}
                        name="treintype"
                        label="Treintype"
                        options={treinTypeOptions}
                        placeholder="IC/ICD/SPR"
                        readOnly={!!treinId}
                    />
                </div>
                <div className="col-span-8">
                    <FormFieldInput form={form} name="treinnummer" label="Treinnummer" placeholder="0000" readOnly={!!treinId} />
                </div>
                <div className="col-span-7">
                    <SelectFormField
                        form={form}
                        label="Materieeltype"
                        name="materieelAanduiding"
                        optional
                        options={getMaterieelTypeOptions(materieelAanduiding)}
                    />
                </div>
                <div className="col-span-5">
                    <FormFieldInput form={form} name="materieelAantalBakken" label="Aantal bakken" optional />
                </div>
                {!treinId && (
                    <div className="col-span-12">
                        <FormFieldInput form={form} name="aantalReizigers" label="Reizigersaantal" optional />
                    </div>
                )}
            </div>
        </div>
    );
}
